import React from "react"

export const ShareIcon = ({
  size = 1,
  color = "#034055",
  stroke_width = "2.5",
}) => {
  return (
    <svg
      width={24 * size}
      height={24 * size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.688 14.634v5.687L22 11.82 12.688 3v5.897S2.491 7.546 2 17.374c0 0 5.344-4.743 10.688-2.74z"
        stroke={color}
        strokeWidth={stroke_width}
        fill="none"
        fillRule="evenodd"
      />
    </svg>
  )
}
